// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  ConfigProvider,
  App,
} from 'antd';
import { ApplyPluginsType } from 'umi';
import { getPluginManager } from '../core/plugin';
import { AntdConfigContext, AntdConfigContextSetter } from './context';
import merge from '/app/node_modules/lodash/merge'

let cacheAntdConfig = null;

const getAntdConfig = () => {
  if(!cacheAntdConfig){
    cacheAntdConfig = getPluginManager().applyPlugins({
      key: 'antd',
      type: ApplyPluginsType.modify,
      initialValue: {
        ...{"theme":{"cssVar":true,"token":{"fontFamily":"AlibabaSans, sans-serif","colorPrimary":"#ff8040","colorBgBase":"#fffaf5","colorBgLayout":"#ffffff","colorBgContainer":"#ffffff","colorBgElevated":"#ffffff","colorLink":"#ff8040","colorLinkHover":"#ffaa66","colorLinkActive":"#e6731a","colorInfo":"#ff8040","colorError":"#f04437","colorSuccess":"#12b76a"},"components":{"Button":{"colorPrimary":"#ff8040","colorPrimaryHover":"#ffaa66","colorPrimaryActive":"#e6731a","colorError":"#f04437","fontWeight":500},"Menu":{"itemSelectedColor":"#ff8040","itemSelectedBg":"#fff4e6","itemHoverColor":"#ff8040","itemHoverBg":"#ffe8cc","itemActiveBg":"#ffd9a3"},"Table":{"rowSelectedBg":"#ffe8cc","rowSelectedHoverBg":"#ffd9a3","headerBg":"rgb(242,244,247)","rowHoverBg":"rgb(242,244,247)","bodySortBg":"rgb(242,244,247)"},"Tabs":{"itemSelectedColor":"#ff8040","itemHoverColor":"#ffaa66","itemActiveColor":"#e6731a","inkBarColor":"#ff8040"}}}},
        appConfig: {},
      },
    });
    if (!cacheAntdConfig.theme) {
      cacheAntdConfig.theme = {};
    }
  }
  return cacheAntdConfig;
}

function AntdProvider({ children }) {
  let container = children;

  const [antdConfig, _setAntdConfig] = React.useState(() => {
    const {
      appConfig: _,
      ...finalConfigProvider
    } = getAntdConfig();
    return finalConfigProvider
  });
  const setAntdConfig: typeof _setAntdConfig = (newConfig) => {
    _setAntdConfig(prev => {
      return merge({}, prev, typeof newConfig === 'function' ? newConfig(prev) : newConfig)
    })
  }


  if (antdConfig.prefixCls) {
    ConfigProvider.config({
      prefixCls: antdConfig.prefixCls,
    });
  };

  if (antdConfig.iconPrefixCls) {
    // Icons in message need to set iconPrefixCls via ConfigProvider.config()
    ConfigProvider.config({
      iconPrefixCls: antdConfig.iconPrefixCls,
    });
  };

  if (antdConfig.theme) {
    // Pass config theme to static method
    ConfigProvider.config({
      theme: antdConfig.theme,
    });
  }

  container = <ConfigProvider {...antdConfig}>{container}</ConfigProvider>;


  container = (
    <AntdConfigContextSetter.Provider value={setAntdConfig}>
      <AntdConfigContext.Provider value={antdConfig}>
        {container}
      </AntdConfigContext.Provider>
    </AntdConfigContextSetter.Provider>
  )

  return container;
}

export function rootContainer(children) {
  return (
    <AntdProvider>
      {children}
    </AntdProvider>
  );
}

// The App component should be under ConfigProvider
// plugin-locale has other ConfigProvider
export function innerProvider(container: any) {
  const {
    appConfig: finalAppConfig = {},
  } = getAntdConfig();
  return <App {...finalAppConfig}>{container}</App>;
}
